import { DialogDescription } from '@radix-ui/react-dialog';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FeatureFlag, getFeatureFlags, toggleFeatureFlag } from '../stores/slices/feature-flags';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './Dialog';
import { Checkbox } from './Input/Checkbox';

export function FeatureFlagModal() {
  const [isOpen, setIsOpen] = useState(false);
  const featureFlags = useSelector(getFeatureFlags());
  const dispatch = useDispatch();

  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.ctrlKey && (event.key === '`' || event.key === '0')) {
        event.preventDefault();
        setIsOpen((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleKeydown);

    return () => window.removeEventListener('keydown', handleKeydown);
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Feature Flags</DialogTitle>
          <DialogDescription>
            {`Toggle application features on and off during development. This modal is unavailable in production and any changes are only saved to this browser's session storage.`}
          </DialogDescription>
        </DialogHeader>

        <ul className="list-non m-0 mt-2 p-0">
          {Object.entries(featureFlags).map(([key, { isEnabled, label }]) => (
            <li key={key} className="mb-2 flex items-center">
              <Checkbox
                name={`${key}-toggle`}
                checked={isEnabled}
                onCheckedChange={() => dispatch(toggleFeatureFlag({ flag: key as FeatureFlag }))}
              ></Checkbox>
              <label htmlFor={`${key}-toggle`} className="ms-2">
                {label} {isEnabled}
              </label>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
